
import ClientHead from "@/components/main/core/ClientHead";
import RedSection from "@/components/main/core/RedSection";
import CheckBox from "@/components/main/core/CheckBox";

export default {

  head() {
    const title = 'Disclaimer ᐈ iFindCheaters';
    const description = 'Read the disclaimer of iFindCheaters regarding the use of our products for catching cheaters online. Understand the terms and conditions regarding the use of our services for catching cheaters online. Learn about limitations, liabilities, and legal information.';

    return {
      title: title,
      meta: [
      {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Legal disclaimer catching cheaters, Limitations of iFindCheaters, Use of iFindCheaters services disclaimer, iFindCheaters service limitations, Terms and conditions iFindCheaters, iFindCheaters disclaimer'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/main/sample-report-bcg.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/disclaimer/",
        },
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Disclaimer",
            }],
          }
        }
      ]
    };
  },

  name: "disclaimer",
  layout: 'clientLayout',
  mixins: [],
  components: {ClientHead, RedSection, CheckBox, },
  data() {
    return {}
  },
  computed: {},
  mounted() {
  },
  methods: {}
}
